module.exports = __webpack_public_path__ + "static/media/Evas.a5540d9d.jpg";